module.exports = __webpack_public_path__ + "static/media/09-001.8d1caaf4.png";